import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14e61024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-validation-component codigoInvitacion" }
const _hoisted_2 = { class: "row justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "column items-center control"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-bold text-center subtitle text-gray8" }, " Si tienes un código de invitación que recibiste en algún curso de capacitación sobre el PIBA ingresalo a continuación. ", -1))
const _hoisted_5 = { class: "idCont" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center q-pa-none q-ma-none text-body-sm" }, " Eliminar código ", -1))
const _hoisted_8 = {
  key: 1,
  class: "row justify-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-12 text-center q-pt-md subtitle" }, " Validando código ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center q-pa-none q-ma-none text-body-sm" }, " Eliminar código ", -1))
const _hoisted_11 = {
  key: 2,
  class: "column items-center control"
}
const _hoisted_12 = { class: "col-12 text-center q-pt-md subtitle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center q-pa-none q-ma-none text-body-sm" }, " Eliminar código ", -1))

import {
  ref, PropType, computed,
} from 'vue';
import { RegisterTerapeutaPersonalData, codigoInvitacionEstado } from 'src/types/initial-evaluation/register-personal-terapeuta';
import { QField } from 'quasar';
import { api, AxiosError } from 'src/boot/axios';
import { to } from 'await-to-js';
import { AxiosResponse } from 'axios';
import { useQuasar } from 'quasar'


export default /*#__PURE__*/_defineComponent({
  __name: 'CodigoInvitacion',
  props: {
  modelValue: {
    type: Object as PropType<RegisterTerapeutaPersonalData['codigoInvitacion']>,
    required: true,
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const $q = useQuasar()





const rValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
const fieldRef = ref<QField>();
function validate() {
  // return fieldRef.value?.validate();
  return true;
}
async function verificarCodigoInvitacion() {
  rValue.value.estado = codigoInvitacionEstado.VALIDANDO;
  const [err, response] = await to<AxiosResponse<string>, AxiosError<{ error: string, message: string, statusCode: number }>>(api.get(`/terapeutas/invitacion/${rValue.value.codigo}`));
  if (err) {
    console.log(err.response?.data.message);
    if (err.response?.data.statusCode === 404) {
      $q.notify({
        type: 'negative',
        message: 'El código no existe',
      });
      rValue.value.estado = codigoInvitacionEstado.NO_ENCONTRADO;
    } else if (err.response?.data.statusCode === 422) {
      $q.notify({
        type: 'negative',
        message: 'El código ha expirado, ponte en contacto con nosotros en soporte@piba.com.mx para solicitar otro.',
      });
      rValue.value.estado = codigoInvitacionEstado.EXPIRADO;
    } else {
      $q.notify({
        type: 'negative',
        message: 'Ocurrio un error validando el código de invitación',
      });
      rValue.value.estado = codigoInvitacionEstado.NO_ENCONTRADO;
    }
  } else {
    rValue.value.id = response?.data;
    rValue.value.estado = codigoInvitacionEstado.ACEPTADO;
  }
}

function eliminarCodigo() {
  rValue.value.estado = codigoInvitacionEstado.SIN_INGRESAR;
  rValue.value.codigo = '';
  rValue.value.id = '';
}



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner_ball = _resolveComponent("q-spinner-ball")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(QField), {
        ref_key: "fieldRef",
        ref: fieldRef,
        modelValue: _unref(rValue),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(rValue) ? (rValue).value = $event : null)),
        borderless: "",
        "stack-label": ""
      }, {
        control: _withCtx(() => [
          (_unref(rValue).estado == null
          || _unref(rValue).estado === _unref(codigoInvitacionEstado).SIN_INGRESAR
          || _unref(rValue).estado === _unref(codigoInvitacionEstado).NO_ENCONTRADO
          || _unref(rValue).estado === _unref(codigoInvitacionEstado).EXPIRADO)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_q_input, {
                    modelValue: _unref(rValue).codigo,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(rValue).codigo) = $event)),
                    outlined: "",
                    rounded: "",
                    class: "",
                    "label-color": "lightgray",
                    label: "Código de Invitación"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        class: "text-lightergray",
                        name: "fa-solid fa-address-card"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    unelevated: "",
                    rounded: "",
                    class: "q-ml-sm",
                    disabled: _unref(rValue).codigo === '',
                    onClick: verificarCodigoInvitacion
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "fa-solid fa-chevron-right",
                        height: "3em",
                        class: "q-py-sm"
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                (_unref(rValue).estado === _unref(codigoInvitacionEstado).EXPIRADO
            || _unref(rValue).estado === _unref(codigoInvitacionEstado).NO_ENCONTRADO)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_q_icon, {
                        class: "title q-mt-sm text-gray8 cursor-pointer",
                        icon: "fa-regular fa-circle-left",
                        onClick: eliminarCodigo
                      }),
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(rValue).estado === _unref(codigoInvitacionEstado).VALIDANDO)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_q_spinner_ball, {
                  color: "primary",
                  class: "col-4",
                  size: "2em"
                }),
                _hoisted_9,
                _createElementVNode("div", null, [
                  _createVNode(_component_q_icon, {
                    class: "title q-mt-sm text-gray8 cursor-pointer",
                    icon: "fa-regular fa-circle-left",
                    onClick: eliminarCodigo
                  }),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(rValue).estado === _unref(codigoInvitacionEstado).ACEPTADO)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, " Código " + _toDisplayString(_unref(rValue).codigo) + " añadido correctamente. ", 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_icon, {
                    class: "title q-mt-sm text-gray8 cursor-pointer",
                    icon: "fa-regular fa-circle-left",
                    onClick: eliminarCodigo
                  }),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})